
import React, { Component } from "react";
import BsyDash from "../../dash/BsyDash";
import { WindowPropsContext, windowProp } from '../component_context.js';
class BsyDashContainer extends Component {
    static defaultProps = {

    }
    constructor(props) {
        super(props)
        this.state = {
         
        };
        this.rel = 'and'
        this.filter = {}
        this.refresWidgetMapTime ={}
        this.refreshNewUpdataTime ={}
        this.refreshMap ={}
        this.widgetsMap = {}
        this.concatFilte = []
        this.quikerComponents =[]
    }
    componentDidMount(){
     
    }
    upOverallSituationValue = (type, newValue) => {
        switch (type) {
            case "rel": this.rel = newValue; break
            case "refresWidgetMapTime": this.refresWidgetMapTime = newValue; break
            case "refreshNewUpdataTime": this.refreshNewUpdataTime = newValue; break
            case "refreshMap": this.refreshMap = newValue; break
            case "filter": this.filter = newValue;break
            case "widgetsMap": this.widgetsMap = newValue; break
            case "concatFilte": this.concatFilte = newValue; break
            case "quikerComponents": this.quikerComponents = newValue; break
            default: { }
        }
    };
    getOverallSituationValue = (type)=>{
        var _this =this
        switch (type) {
            case "rel": return this.rel;
            case "refresWidgetMapTime":  return _this.refresWidgetMapTime;
            case "refreshNewUpdataTime":  return _this.refreshNewUpdataTime;
            case "refreshMap":  return _this.refreshMap;
            case "filter":return JSON.parse(JSON.stringify(_this.filter));
            case "widgetsMap":  return _this.widgetsMap;
            case "concatFilte":  return _this.concatFilte;
            case "quikerComponents":  return _this.quikerComponents;
            default: { }
        }
    }
   
    render() {
        return (
            <WindowPropsContext.Provider value={{
                rel: this.rel,
                refresWidgetMapTime: this.refresWidgetMapTime,
                refreshNewUpdataTime: this.refreshNewUpdataTime,
                refreshMap: this.refreshMap,
                filter: this.filter,
                widgetsMap: this.widgetsMap,
                getOverallSituationValue:this.getOverallSituationValue,
                upOverallSituationValue: this.upOverallSituationValue
            }}>
                <BsyDash  {...this.props}></BsyDash>
            </WindowPropsContext.Provider>

        )

    }
};

export default BsyDashContainer
